import dataRoamingApi from '@/api/dataRoaming/dataRoamingApi'
import event from '@/event-bus/event';
import { Validator } from 'vee-validate';

export default {
	name: 'data-roaming',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			dataBasicStatus: {
				serviceList: [], // 查詢服務清單
				dataRoamFlag: '', // 數據漫遊功能開關
				hisRoamStartDateFormat:'', // 數據漫遊啟用日
				hisRoamEndDateFormat:'' // 數據漫遊關閉日
			}, // 用戶數據漫遊功能申請狀態
			selectRoamingOperator: '', // 所選擇的方案
			pickupStart: '', // 預約生效日
			pickupEnd: '', // 預約到期日
			roamServiceList:{}, // 目前Combovalue Table上有效的設定資訊
			countryMap: {}, // 優惠方案物件
			selectDaily: '', // 日租/非日租
			dailyRentShow: false, // 是否顯示購買日租按鈕
			nonDailyRentShow: false, // 是否顯示購買非日租按鈕
			roamSIMType: '', // SIM卡種類
			countryRoamList: [], // Single卡支援的國家清單
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.getDataBasicStatus();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async getDataBasicStatus() {
			// 查詢用戶數據漫遊功能申請狀態
			this.dataBasicStatus = await dataRoamingApi.getDataBasicStatus();
			if(this.dataBasicStatus.serviceList){
				this.dataBasicStatus.serviceList = this.dataBasicStatus.serviceList.filter(service => service.roamingType == 1);
			}
			// 取得優惠方案列表
			this.countryMap = await dataRoamingApi.getCountryMap();

			// 呼叫CRM得到方案清單
			this.roamServiceList = await dataRoamingApi.getRoamServiceList();

			// 取得SIM卡種類
			this.roamSIMType = await dataRoamingApi.getRoamSIMType();

			// 取得Single卡支援的國家清單
			this.countryRoamList = await dataRoamingApi.getCountryRoamingItem();

		},
		closeDataRoaming() {
			const dataRoamFlagSwitch = {
				isShow: true,
				showReservationWarn: false,
				dataRoamFlag: this.dataBasicStatus.dataRoamFlag
			}
			// 關閉大開關
			this.$bus.$emit(event.switchDataRoamingAlert, dataRoamFlagSwitch );
		},
		async changeSelectDaily() {
			this.nonDailyRentShow = (this.selectDaily == '非日租');
			this.dailyRentShow = (this.selectDaily == '日租');
		},
		confirm() {
			if(this.selectRoamingOperator == '非日租' || this.selectRoamingOperator.value == '非日租型') {
				this.addNonDailyRent();
			} else{
				this.addDailyRent();
			}
		},
		async addNonDailyRent() {
			// 購買非日租
			const dataRoamFlagSwitch = {
				isShow: (this.dataBasicStatus.serviceList && this.dataBasicStatus.serviceList.length > 0),
				showReservationWarn: (this.dataBasicStatus.serviceList && this.dataBasicStatus.serviceList.length > 0),
				dataRoamFlag: this.dataBasicStatus.dataRoamFlag
			}

			// if (this.roamSIMType == 'S') {
			// 	this.$bus.$emit(event.countryRoamingAlert, null, null, dataRoamFlagSwitch);
			// }
			// else {
			this.$bus.$emit(event.switchDataRoamingAlert , dataRoamFlagSwitch );
			// }
			
		},
		addDailyRent() {
			var errMsg = "";
			// 已申請的優惠的電信業者
			let serviceListOperators = this.dataBasicStatus.serviceList ?
				Object.values(this.dataBasicStatus.serviceList).map(service => service.operator) : null;

			this.pickupStart = $('#pickupStart').val();
			this.pickupEnd = $('#pickupEnd').val();

			if(this.selectRoamingOperator == ''){
				if(this.roamSIMType == 'S') {
					errMsg = '請選擇國家'
				} else {
					errMsg = '請選擇方案'
				}
			} else if (!this.pickupStart || !this.pickupEnd) {
				errMsg = '請選擇起迄日期';
			} else if (Date.parse(this.pickupStart).valueOf() >= Date.parse(this.pickupEnd).valueOf()) {
				errMsg = '起始日期不可小於等於結束日期';
			} else if (this.dataBasicStatus.dataRoamFlag == 'Y' && serviceListOperators 
				  && ((this.roamSIMType == 'D' && serviceListOperators.includes(this.selectRoamingOperator.subvalue1)) ||
				       this.roamSIMType == 'S' && serviceListOperators.includes(this.selectRoamingOperator.subvalue1)) ) {
				errMsg = '同一個方案，不能買兩次優惠';
			}

			if(errMsg){
				// 顯示錯誤訊息
				this.$bus.$emit(event.validateAlert, errMsg);
			}
			else {
				const roamItem = {
					roamingOperator: {
						sortOrder: '',
						subvalue1: '',
						subvalue2: '',
						value: ''
					},
					pickupStart: this.pickupStart,
					pickupEnd: this.pickupEnd,
					showWarnMsg: (this.dataBasicStatus.dataRoamFlag == 'N' && this.dataBasicStatus.serviceList && this.dataBasicStatus.serviceList.length > 0),
				}

				// if (this.roamSIMType == 'S') {
				// 	roamItem.roamingOperator.value = this.selectRoamingOperator[0];
				// 	roamItem.roamingOperator.subvalue1 = this.selectRoamingOperator[1];
				// 	this.$bus.$emit(event.countryRoamingAlert, null, roamItem, null);
				// } else {
					roamItem.roamingOperator = this.selectRoamingOperator;
					// 顯示確認購買訊息
					this.$bus.$emit(event.addRoamItemAlert, roamItem);
				// }
				
			}
		},
		async removeDateRoamingItem(operator, start, end) {
			const ftRemoveDateRoamingItem = {
				operator: operator,
				start: start,
				end: end
			}
			// 取消優惠方案
			let res = await dataRoamingApi.removeDateRoamingItem(ftRemoveDateRoamingItem);
			if (res) {
				this.$router.push({ name: 'gt-success', params: { returnName: 'data-roaming', title: '國際數據漫遊服務', msg: '國際數據漫遊服務已設定成功'}});
			}
		},
		checkDiscountPlan(service) {
			// Check是否提供取消優惠方案按鈕:  取消優惠：檢查優惠啟用日，若小於等於今天，則不提供取消。檢查優惠啟用日，若大於今天，則提供取消
			return Date.parse(service.roamStartDateStr).valueOf() <= new Date();
		},
		getOperator(operator) {
			let item = null;
			// 取得直連業者
			if (this.countryRoamList){
				item = this.countryRoamList.find(i => i.roamOperator == operator);
			}
			
			if(item && item.value == '日租599') {
				let diaryStr = '';
				let isFirst = true;
				this.countryRoamList.forEach((i) => {
					if(i.value == '日租599') {
						if(isFirst) {
							isFirst = false;
							diaryStr += i.operator;
						} else {
							diaryStr = diaryStr + '<br>' + i.operator;
						}
					}
					
				});
				return diaryStr;
			}
			
			return item && item.operator;
		},
		getDataPlan(operator){
			let item = null;
			// 取得方案名稱
			if (this.countryRoamList){
				item = this.countryRoamList.find(i => i.roamOperator == operator);
			}
			
			return item && item.value;
		},
		getCountryList(){
			const countryList = new Map();
			// 2024/5/30 篩選掉非日租型
			this.countryRoamList.filter(e => e.value != '非日租型').forEach(e =>countryList.set(e.countryName, {roamOperator: e.roamOperator, value: e.value}));
			let result = [];
			countryList.forEach( (val, key) => {
				result.push({value: val.value, subvalue1: val.roamOperator, countryName: key});
			});
			return result;
		},
		showCountryWarning() {
			this.$bus.$emit(event.countryRoamingAlert, null, null, null, () => {
				this.dailyRentShow = true;
			});
		},
		countryChange() {
			if(this.selectRoamingOperator == '其他國家') {
				this.$bus.$emit(event.validateAlert, '請洽客服或直營門市進行換卡');
				this.selectRoamingOperator = '';
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/dataRoaming/dataRoaming.js